import React from 'react'
import AdminLayout from '../../components/admin/AdminLayout'

const TeamManage = () => {
  return (
    <AdminLayout>
<div>Coming Soon.......</div>
    </AdminLayout>
    
  )
}

export default TeamManage
